/* Halloween 2026 (proy-5). Lo carga snippets/hw2026-head.liquid. Fuera de EE. UU., solo en la visita del
   anuncio (sin ella, clase hw2026-off: nada) y solo en lo de niño (clase hw2026-eu).
   1. Grids de producto (colecciones y búsqueda): una fila sí y otra no lleva algo de Halloween.
      Si la fila ya tiene un hueco (personaje o copy) cuenta como «sí»; si no, se le pone una
      decoración (araña, murciélagos, telaraña, escoba, por turnos) en la tarjeta de la izquierda o
      de la derecha. Las filas con banner cuentan como filas normales
      (sus dos tarjetas libres pueden llevar decoración). Se miden en pantalla: vale para 4 y 2 columnas.
   2. PDP: araña colgando de la primera foto visible (collage en PC, carrusel en móvil).
   3. Home: la araña baja colgando cuando se ha pasado el hero, y vuelve a subir si se vuelve arriba.
   4. Avatar: las letras de sus copies, cada una en su span, para la animación de relámpago.
   5. Modo oscuro de la colección kids en USA (clase hw2026-dark en <html>): repasa lo que no sigue las variables. */
(function () {
  var cfgEl = document.getElementById('hw2026-config');
  if (!cfgEl) return;
  var html = document.documentElement;
  if (html.classList.contains('hw2026-off')) return;
  var cfg = JSON.parse(cfgEl.textContent);

  // Fuera de EE. UU. (hw2026-eu), solo en productos de niño: ni adulto ni accesorios.
  var eu = html.classList.contains('hw2026-eu');
  function kidsCard(card) {
    return !eu || cfg.kidsTpl.indexOf(card.getAttribute('data-lj-tpl')) !== -1;
  }

  function img(src, w, h, className, style) {
    var el = document.createElement('img');
    el.src = src;
    el.alt = '';
    el.width = w;
    el.height = h;
    if (className) el.className = className;
    if (style) el.setAttribute('style', style);
    return el;
  }

  // Estela de la escoba: x, y del ad de 1080 px y segundo en que se enciende (una de cada tres del ad).
  var TRAIL = [[1054, 532, 1.38], [910, 507, 1.68], [767, 442, 1.98], [626, 350, 2.28], [486, 270, 2.58],
    [345, 231, 2.88], [204, 221, 3.18], [61, 207, 3.48], [-81, 166, 3.78]];

  function deco(kind, extraClass) {
    var wrap = document.createElement('span');
    wrap.className = 'hw2026-deco hw2026-deco--' + kind + (extraClass ? ' ' + extraClass : '');
    wrap.setAttribute('aria-hidden', 'true');
    if (kind === 'spider') wrap.appendChild(img(cfg.spider, 2048, 2048, 'hw2026-spider'));
    if (kind === 'web') wrap.appendChild(img(cfg.web, 1024, 1024));
    if (kind === 'bats') {
      // Los murciélagos del copy del vampiro, 3 en vez de 6 para no tapar el producto.
      wrap.className += ' hw2026-anim';
      [[100, 0], [180, 0.6], [144, 1.2]].forEach(function (b) {
        var bat = document.createElement('span');
        bat.className = 'hw2026-anim__bat';
        bat.setAttribute('style', '--w:' + b[0] + ';--d:' + b[1] + 's');
        bat.appendChild(img(cfg.batA, 380, 315));
        bat.appendChild(img(cfg.batB, 380, 315));
        wrap.appendChild(bat);
      });
    }
    if (kind === 'broom') {
      wrap.className += ' hw2026-anim';
      TRAIL.forEach(function (t) {
        wrap.appendChild(img(cfg.trail, 400, 400, 'hw2026-anim__trail', '--x:' + t[0] + ';--y:' + t[1] + ';--d:' + t[2] + 's'));
      });
      wrap.appendChild(img(cfg.broom, 806, 247, 'hw2026-anim__broom'));
    }
    return wrap;
  }

  // En el avatar barefoot la araña y la telaraña van dentro de sus copies: en las tarjetas, solo
  // murciélagos y escoba.
  var KINDS = cfg.avatar ? ['bats', 'broom'] : ['spider', 'bats', 'web', 'broom'];

  // Una fila «tiene algo» si la cruza un hueco de Halloween o una infografía del avatar.
  function isSpecial(el) {
    return el.classList.contains('hw2026-tile') || el.classList.contains('lj-bf-grid-item');
  }

  function decorateGrid(grid) {
    var items = Array.prototype.filter.call(grid.children, function (el) { return el.offsetParent !== null; });
    var cards = items.filter(function (el) { return el.tagName === 'PRODUCT-BLOCK'; });
    var specials = items.filter(isSpecial);

    // Filas = alturas distintas de las tarjetas. Una fila «tiene algo» si un hueco de Halloween la cruza.
    var rows = [];
    cards.forEach(function (card) {
      var top = card.offsetTop;
      var row = rows.find(function (r) { return Math.abs(r.top - top) < 4; });
      if (!row) rows.push(row = { top: top, cards: [] });
      row.cards.push(card);
    });
    rows.sort(function (a, b) { return a.top - b.top; });

    rows.forEach(function (row) {
      row.special = specials.some(function (s) {
        return s.offsetTop <= row.top + 4 && s.offsetTop + s.offsetHeight > row.top + 4;
      });
    });

    // En kids de PC (huecos en las filas impares) toda fila sin hueco lleva decoración: así cada fila
    // tiene algo. En el resto, y en kids de móvil, una fila sí y otra no.
    var everyRow = !cfg.avatar && specials.length > 0 && rows.some(function (r) { return r.cards.length >= 3; });
    var plan = [];
    var done = 0;
    var previousHadSomething = false;
    var previousDecorated = false;
    rows.forEach(function (row, i) {
      if (row.special) { previousHadSomething = true; previousDecorated = false; return; }
      if (cfg.avatar) {
        // Avatar: sus huecos e infografías ocupan pocas filas, así que se decora toda fila vacía que no
        // venga justo después de otra decorada (sin dos bichos seguidos).
        if (previousDecorated) { previousDecorated = false; return; }
      } else if (!everyRow && (previousHadSomething || (rows[i + 1] && rows[i + 1].special))) {
        // Una fila sí y otra no; y sin decorar justo encima de una fila que ya trae hueco.
        previousHadSomething = false;
        return;
      }

      row.cards.sort(function (a, b) { return a.offsetLeft - b.offsetLeft; });
      // Lado: izquierda, derecha… y cada 4 filas se invierte, para que cada decoración no caiga siempre en el mismo lado.
      var left = (done + Math.floor(done / 4)) % 2 === 0;
      var ends = [row.cards[0], row.cards[row.cards.length - 1]];
      if (!left) ends.reverse();
      // Si la de ese lado no es de niño, la del otro; si ninguna lo es, la fila se queda sin nada.
      var card = ends.find(kidsCard);
      if (!card) return;
      var host = card.querySelector('.image-cont');
      if (host) plan.push({ host: host, kind: KINDS[done % KINDS.length] });
      done++;
      previousHadSomething = true;
      previousDecorated = true;
    });

    // Si ya están donde tocan no se rehacen: las imágenes lazy disparan el observador y las animaciones
    // volverían a empezar a cada rato.
    var current = grid.querySelectorAll('.hw2026-deco');
    var same = current.length === plan.length && plan.every(function (d, i) {
      return current[i].parentElement === d.host && current[i].classList.contains('hw2026-deco--' + d.kind);
    });
    if (same) return;
    current.forEach(function (n) { n.remove(); });
    plan.forEach(function (d) { d.host.appendChild(deco(d.kind)); });
  }

  function decoratePdp() {
    var first = Array.prototype.find.call(
      document.querySelectorAll('.product-media-collage__item'),
      function (el) { return el.getClientRects().length > 0; }
    );
    var carousel = document.querySelector('.main-image carousel-slider');
    var placed = document.querySelectorAll('.hw2026-deco--pdp');
    // Igual que en los grids: si ya está en la foto que toca, no se rehace.
    if (placed.length === (first ? 1 : 0) + (carousel ? 1 : 0) &&
      Array.prototype.every.call(placed, function (n) { return n.parentElement === first || n.parentElement === carousel; })) return;
    placed.forEach(function (n) { n.remove(); });
    if (first) {
      first.classList.add('hw2026-pdp-host');
      first.appendChild(deco('spider', 'hw2026-deco--pdp'));
    }
    // En móvil va sobre el carrusel y no dentro de una slide: el carrusel clona slides (data-loop).
    if (carousel) {
      carousel.classList.add('hw2026-pdp-host');
      carousel.appendChild(deco('spider', 'hw2026-deco--pdp hw2026-deco--pdp-mobile'));
    }
  }

  // Avatar: cada letra en su span (--i = orden) para que se enciendan una tras otra. Las palabras van
  // en un span sin cortes para que el texto siga partiendo igual en líneas; el lector lee el aria-label.
  // Se repite en cada run(): los filtros por AJAX vuelven a pintar los copies con el texto entero.
  function splitLetters() {
    document.querySelectorAll('.hw2026-tile__scary:not([aria-label])').forEach(function (p) {
      var text = p.textContent.trim();
      var i = 0;
      p.setAttribute('aria-label', text);
      p.textContent = '';
      text.split(/\s+/).forEach(function (word, w) {
        if (w) p.appendChild(document.createTextNode(' '));
        var wordEl = document.createElement('span');
        wordEl.className = 'hw2026-word';
        wordEl.setAttribute('aria-hidden', 'true');
        Array.from(word).forEach(function (ch) {
          var l = document.createElement('span');
          l.className = 'hw2026-letter';
          l.style.setProperty('--i', i++);
          l.textContent = ch;
          wordEl.appendChild(l);
        });
        p.appendChild(wordEl);
      });
    });
  }

  var timer;
  function run() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      splitLetters();
      if (cfg.grid) {
        document.querySelectorAll('.product-grid:not(.product-grid--carousel)').forEach(decorateGrid);
      }
      if ((!eu || cfg.kidsProduct) && document.querySelector('.product-media-collage, .main-image carousel-slider')) decoratePdp();
    }, 150);
  }

  var homeSpider = document.querySelector('.hw2026-home-spider');
  if (homeSpider) {
    var hero = document.querySelector('#content .shopify-section');
    var onScroll = function () {
      var limit = hero ? hero.offsetTop + hero.offsetHeight - window.innerHeight * 0.3 : window.innerHeight;
      homeSpider.classList.toggle('is-down', window.scrollY > limit);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  run();
  window.addEventListener('resize', run);
  // Filtros y paginación por AJAX, Geosort y el reordenado por región cambian el grid; el cambio de
  // variante oculta o enseña fotos de la galería. Lo nuestro no vuelve a disparar el observador.
  new MutationObserver(function (mutations) {
    var ours = mutations.every(function (m) {
      return Array.prototype.every.call(m.addedNodes, function (n) { return n.classList && n.classList.contains('hw2026-deco'); }) &&
        Array.prototype.every.call(m.removedNodes, function (n) { return n.classList && n.classList.contains('hw2026-deco'); }) &&
        m.type === 'childList';
    });
    if (!ours) run();
  }).observe(document.getElementById('content') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });

  // 5. Modo oscuro. Las variables (hw2026.css) cambian casi todo; aquí se repasa lo que trae el color
  // escrito a mano: un fondo claro pasa a negro, un botón oscuro sobre negro pasa a blanco, y un texto
  // que no llega a 4,5:1 contra su fondo pasa a blanco o a negro. Va en estilo en línea con prioridad
  // porque muchas de esas reglas llevan !important. No se tocan las fotos, el texto que va encima de
  // una foto, los fondos puestos en el propio HTML, los huecos de Halloween ni los popups de Klaviyo.
  if (!html.classList.contains('hw2026-dark')) return;

  var KEEP = '.hw2026-tile, .hw2026-deco, .lej-ck, [class*="klaviyo"], .needsclick, .image-cont, .card__media, .media, ' +
    '.product-media, .product-media-collage__item, .lj-bf-info, .lj-bf-slide, shopify-accelerated-checkout, ' +
    '.shopify-payment-button, [class*="shopify-payment"], [class*="shop-pay"], img, picture, video, svg, iframe, canvas';
  var BUTTON = 'button, .btn, .button, [class*="btn"], [class*="checkout"], [class*="cta"], [role="button"], [type="submit"]';

  function rgba(str) {
    var m = str.match(/[\d.]+/g) || [0, 0, 0, 0];
    return { r: +m[0], g: +m[1], b: +m[2], a: m[3] === undefined ? 1 : +m[3] };
  }
  function lum(c) {
    function ch(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * ch(c.r) + 0.7152 * ch(c.g) + 0.0722 * ch(c.b);
  }
  function contrast(a, b) {
    var x = lum(a), y = lum(b);
    return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
  }
  function hasOwnText(el) {
    return Array.prototype.some.call(el.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
  }
  // Fotos grandes en pantalla (en coordenadas de la página), medidas una vez por pasada.
  var photos = [];
  function measurePhotos() {
    photos = [];
    document.querySelectorAll('img, video').forEach(function (m) {
      // Las de un menú o cajón cerrado no cuentan: siguen en su sitio pero no se ven.
      if (m.checkVisibility && !m.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return;
      // Una foto lazy aún sin cargar no pinta nada (la del menú móvil, montada pero transparente).
      if (m.tagName === 'IMG' && !m.naturalWidth) return;
      // Ni las que tapa otra parte de la página (la foto del menú móvil, plegado detrás de la ficha). Lo
      // que hay encima en su centro tiene que ser de su misma sección; si queda fuera de pantalla, vale.
      var mr = m.getBoundingClientRect();
      var cx = mr.left + mr.width / 2, cy = mr.top + mr.height / 2;
      if (cx > 0 && cy > 0 && cx < innerWidth && cy < innerHeight) {
        var top = document.elementFromPoint(cx, cy);
        var section = m.closest('.shopify-section, section') || document.body;
        if (top && !section.contains(top)) return;
      }
      // Recortada a su caja: hay fotos de zoom más grandes que el hueco que las enseña.
      var r = m.getBoundingClientRect();
      var c = m.parentElement.getBoundingClientRect();
      var box = { left: Math.max(r.left, c.left), right: Math.min(r.right, c.right), top: Math.max(r.top, c.top), bottom: Math.min(r.bottom, c.bottom) };
      if ((box.right - box.left) * (box.bottom - box.top) > 20000 && box.right > box.left) { box.el = m; photos.push(box); }
    });
  }
  // Se mide el texto, no la caja: un título a todo el ancho tiene el centro encima de la foto de al lado.
  var range = document.createRange();
  function overPhoto(el) {
    var t = Array.prototype.find.call(el.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
    range.selectNodeContents(t || el);
    var r = range.getBoundingClientRect();
    var x = r.left + r.width / 2, y = r.top + r.height / 2;
    return photosAt(x, y);
  }
  function photosAt(x, y) {
    return photos.filter(function (p) { return x >= p.left && x <= p.right && y >= p.top && y <= p.bottom; })
      .map(function (p) { return p.el; });
  }
  // Primer fondo opaco subiendo desde n. null si antes se llega a la foto que hay debajo (el texto va
  // encima de ella) o a un fondo con imagen. Una cabecera fija con fondo propio sí cuenta como fondo.
  function firstBackground(n, under) {
    for (; n && n !== document.documentElement; n = n.parentElement) {
      if (under.some(function (m) { return n.contains(m); })) return null;
      var cs = getComputedStyle(n);
      if (cs.backgroundImage !== 'none') return null;
      var bg = rgba(cs.backgroundColor);
      if (bg.a > 0.5) return bg;
    }
    return { r: 0, g: 0, b: 0, a: 1 };
  }
  // Un contenedor cuya foto ocupa más del 60 % es parte de la foto: su fondo es el de la foto
  // (infografías, comparativas) y si se pinta de negro se ve el corte.
  function holdsPhoto(el) {
    var box = el.getBoundingClientRect();
    var area = box.width * box.height;
    // Se cuenta solo la parte de la foto que cae dentro del contenedor (hay fotos de zoom más grandes que él).
    return area > 0 && Array.prototype.some.call(el.querySelectorAll('img, video'), function (m) {
      var r = m.getBoundingClientRect();
      var w = Math.min(r.right, box.right) - Math.max(r.left, box.left);
      var h = Math.min(r.bottom, box.bottom) - Math.max(r.top, box.top);
      return w > 0 && h > 0 && w * h > area * 0.6;
    });
  }
  // Fondo real detrás de un texto: el primero opaco subiendo. null si el texto va encima de una foto
  // (se mide por posición: el texto de al lado de una foto sí se revisa).
  function backdrop(el) {
    return firstBackground(el, overPhoto(el));
  }
  var WHITE = { r: 255, g: 255, b: 255 };

  // Gráficos: iconos y logos oscuros (SVG en línea o imagen con transparencia) sobre fondo negro se
  // invierten. Los de color (pagos, banderas) y las fotos no: solo si casi todo lo que pintan es oscuro.
  var GFX_SKIP = '.hw2026-tile, .hw2026-deco, .hw2026-home-spider, .logo__image, .logo__image-transparent, .lej-ck, ' +
    '[class*="klaviyo"], .needsclick, .lj-bf-info, .lj-bf-slide, shopify-accelerated-checkout, [class*="shopify-payment"], ' +
    '[class*="shop-pay"], .image-cont, .card__media, .media, .product-media, .product-media-collage__item';
  var probe = document.createElement('canvas');
  probe.width = probe.height = 24;
  function darkGraphic(g) {
    if (g.tagName === 'svg') {
      var cols = [];
      Array.prototype.slice.call(g.querySelectorAll('path, circle, rect, line, polyline, polygon, ellipse, text, use'), 0, 16).forEach(function (x) {
        var c = getComputedStyle(x);
        [c.fill, c.stroke].forEach(function (v) { if (v && v !== 'none' && v.indexOf('url') < 0) cols.push(rgba(v)); });
      });
      cols = cols.filter(function (c) { return c.a > 0; });
      return cols.length > 0 && cols.every(function (c) { return lum(c) < 0.05; });
    }
    try {
      var ctx = probe.getContext('2d', { willReadFrequently: true });
      ctx.clearRect(0, 0, 24, 24);
      ctx.drawImage(g, 0, 0, 24, 24);
      var d = ctx.getImageData(0, 0, 24, 24).data, ink = 0, dark = 0, clear = 0;
      for (var k = 0; k < d.length; k += 4) {
        if (d[k + 3] < 25) { clear++; continue; }
        ink++;
        if (d[k] + d[k + 1] + d[k + 2] < 150) dark++;
      }
      // Necesita transparencia (un logo o icono, no una foto) y casi toda la tinta oscura.
      return clear > 576 * 0.2 && ink > 5 && dark / ink > 0.9;
    } catch (e) {
      return /black|negro|000000/i.test(g.currentSrc); // imagen de otro dominio: solo por el nombre
    }
  }
  function sweepGraphics() {
    document.querySelectorAll('svg, img').forEach(function (g) {
      if (g.hasAttribute('data-hw2026-gfx') || g.closest(GFX_SKIP)) return;
      if (g.tagName === 'svg' && g.parentElement.closest('svg')) return;
      var r = g.getBoundingClientRect();
      if (!r.width || r.width * r.height > 120000) return;
      if (g.tagName === 'IMG' && !g.naturalWidth) return;
      // Encima de una foto no se toca; si no, el fondo es el primero opaco subiendo.
      var bg = firstBackground(g.parentElement, photosAt(r.left + r.width / 2, r.top + r.height / 2));
      if (!bg || lum(bg) > 0.05) return;
      // Los SVG que pintan con currentColor (el carrito de la cabecera, con máscara) se arreglan con el color.
      // (Hay reglas de cabecera que fijan el color de cada hijo con !important: va a todos.)
      if (g.tagName === 'svg' && lum(rgba(getComputedStyle(g).color)) < 0.05) {
        [g].concat(Array.prototype.slice.call(g.querySelectorAll('*'))).forEach(function (x) { x.style.setProperty('color', '#fff', 'important'); });
      }
      // Un logo que el theme ya pinta en negro con filtro (brightness(0), el wordmark de Sakura de las
      // editoriales de la ficha): se pasa a blanco con el mismo filtro.
      if (/brightness\(0\)/.test(getComputedStyle(g).filter)) {
        g.style.setProperty('filter', 'brightness(0) invert(1)', 'important');
        g.setAttribute('data-hw2026-gfx', '');
        return;
      }
      if (!darkGraphic(g)) return;
      g.style.setProperty('filter', 'invert(1)', 'important');
      g.setAttribute('data-hw2026-gfx', '');
    });
  }

  function sweepDark() {
    var els = document.body.getElementsByTagName('*');
    var i, el, cs, bg;
    measurePhotos();
    for (i = 0; i < els.length; i++) {
      el = els[i];
      // El fondo de cada elemento se decide una sola vez: con los estilos ya puestos, una segunda pasada
      // lo vería distinto y lo volvería a cambiar (botón blanco → fondo claro → negro…). El color del
      // texto sí se revisa siempre: depende del fondo, que ya no cambia.
      if (el.hasAttribute('data-hw2026-bg') || el.closest(KEEP)) continue;
      cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.backgroundImage !== 'none') continue;
      // Un fondo pequeño puesto en el propio HTML (los círculos de color de los filtros) es contenido: se respeta.
      if (el.style.backgroundColor && el.offsetWidth <= 64 && el.offsetHeight <= 64) continue;
      bg = rgba(cs.backgroundColor);
      if (bg.a <= 0.5) continue;
      // Iconos pintados con máscara (los de la cabecera): su color es el fondo. Oscuro → blanco.
      if ((cs.maskImage || cs.webkitMaskImage || 'none') !== 'none') {
        if (lum(bg) < 0.2) {
          el.style.setProperty('background-color', '#fff', 'important');
          el.setAttribute('data-hw2026-bg', '');
        }
        continue;
      }
      // Un botón claro ya contrasta sobre negro (los CTA blancos del modo oscuro): se deja; su texto lo
      // revisa la segunda vuelta.
      if (lum(bg) > 0.35 && el.matches(BUTTON)) {
        // Salvo en un grupo de pestañas: si el hermano activo era oscuro y ha pasado a blanco, este
        // (el inactivo) pasa a negro para que se siga viendo cuál está elegido.
        var group = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (b) { return b !== el && b.matches(BUTTON); }) : [];
        if (group.some(function (b) { return b.hasAttribute('data-hw2026-was-dark') || lum(rgba(getComputedStyle(b).backgroundColor)) < 0.02; })) {
          el.style.setProperty('background-color', '#000', 'important');
          el.style.setProperty('color', '#fff', 'important');
          el.setAttribute('data-hw2026-bg', '');
        }
        continue;
      }
      if (lum(bg) > 0.35) {
        // El blanco puro es fondo de sección (el marco de «Nuestras tiendas»); el gris o crema que rodea
        // una foto es el de la propia foto.
        if (!(bg.r === 255 && bg.g === 255 && bg.b === 255) && holdsPhoto(el)) continue;
        el.style.setProperty('background-color', '#000', 'important');
        el.setAttribute('data-hw2026-bg', '');
      } else if (lum(bg) < 0.2 && el.matches(BUTTON)) {
        // CTA oscuro o gris (añadir a la cesta, finalizar compra, añadir el match): al revés, blanco
        // con texto negro, que es lo que contrasta sobre la página negra.
        el.style.setProperty('background-color', '#fff', 'important');
        el.style.setProperty('color', '#000', 'important');
        el.setAttribute('data-hw2026-bg', '');
        el.setAttribute('data-hw2026-was-dark', '');
      }
    }
    for (i = 0; i < els.length; i++) {
      el = els[i];
      if (!hasOwnText(el) || el.closest(KEEP)) continue;
      cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      bg = backdrop(el);
      if (!bg || contrast(rgba(cs.color), bg) >= 4.5) continue;
      el.style.setProperty('color', lum(bg) > 0.18 ? '#000' : '#fff', 'important');
    }
  }

  // Cajones, menús y filtros pintan contenido nuevo o cambian de clase al abrirse: se repasa otra vez.
  // Como mucho una pasada cada 300 ms: carruseles y animaciones cambian clases sin parar y con un
  // debounce normal la pasada no llegaría nunca.
  var darkTimer = null;
  var lateTimer = null;
  var darkObserver;
  function sweepAll() {
    sweepDark();
    sweepGraphics();
    darkObserver.takeRecords(); // los cambios de la propia pasada no cuentan
  }
  function queueSweep() {
    if (darkTimer) return;
    darkTimer = setTimeout(function () {
      darkTimer = null;
      sweepAll();
      // Y otra pasada al acabar las transiciones de color (la cabecera tarda en cambiar al hacer scroll):
      // la primera puede haber medido el color a medio camino.
      clearTimeout(lateTimer);
      lateTimer = setTimeout(sweepAll, 700);
    }, 300);
  }
  queueSweep();
  window.addEventListener('load', queueSweep);
  // Las fotos lazy cambian de tamaño al cargar sin tocar el DOM: también se repasa entonces.
  document.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') queueSweep(); }, true);
  // La cabecera cambia de estado al hacer scroll (transparente sobre el hero, opaca después), a veces
  // con una clase en <html>, que el observador no ve: también se repasa al hacer scroll.
  window.addEventListener('scroll', queueSweep, { passive: true });
  // También 'style': hay piezas que se enseñan cambiando su estilo en línea (el título de la ficha en móvil).
  darkObserver = new MutationObserver(queueSweep);
  darkObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-expanded'] });
})();
